import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-card-page-visits",
  templateUrl: "./card-page-visits.component.html",
})
export class CardPageVisitsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
